<template>
  <div
    class="v-view chart-view a-fadeIn"
    :style="{ height: span * 33.33 + '%' }"
  >
    <div class="v-title">
      {{ title }}
      <img src="../assets/images/jc/video.png" alt="" @click="toDetail(1)" />
    </div>
    <div class="ElderlyData-content">
      <div class="sbI-left SBI-flex">
        <div class="title">智能设备</div>
        <!-- <p>门磁：<span>1312</span>人</p>
          <p>摄像头：<span>1480</span>人</p>
          <p>可通话胸卡：<span>1013</span>人</p>
          <p>烟雾报警器：<span>1480</span>人</p>
          <p>红外探测器：<span>1593</span>人</p>
          <p>水浸探测器：<span>1490</span>人</p>
          <p>可燃气体报警器：<span>1593</span>人</p>
          <p>可通话一键呼叫器：<span>1593</span>人</p> -->
        <div class="item-content">
          <template v-if="ideDevice.length > 0">
            <p
              v-for="(item, key) in ideDevice"
              :key="key"
              :id="item.type"
              @click="toDetail(item)"
            >
              {{ item.name }}：<span>{{ item.total }}</span>
            </p>
          </template>

          <p v-else>暂无数据</p>
        </div>
      </div>
      <div class="sbI-right SBI-flex">
        <div class="title">适老化设备</div>
        <!-- <p>感应灯：<span>2290</span>人</p>
          <p>助听器：<span>1227</span>人</p>
          <p>血压计：<span>2400</span>人</p>
          <p>智能药盒：<span>1095</span>人</p>
          <p>多功能手杖：<span>1097</span>人</p>
          <p>带灯放大镜：<span>210</span>人</p>
          <p>电子温度计：<span>980</span>人</p> -->
        <div class="item-content">
          <template v-if="agedDevice.length > 0">
            <p
            v-for="(item, key) in agedDevice"
            :key="key"
            :id="item.type"
          >
            {{ item.name }}：<span>{{ item.total }}</span>
          </p>
          </template>
          <p v-else>暂无数据</p>
        </div>
      </div>
    </div>
    <JCElderDetail></JCElderDetail>
  </div>
</template>

<script>
import { Mixins } from "../minix/index";
import PubSub from "pubsub-js";
import { mapGetters } from "vuex";
import JCElderDetail from "./JCElderDetail.vue";

export default {
  name: "JCSBInstallation",
  mixins: [Mixins],
  components: {
    JCElderDetail,
  },
  computed: {
    ...mapGetters(["cid"]),
  },
  props: {
    type: {
      type: String,
      default: "pie",
    },
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: "设备安装情况",
    },
  },
  watch: {},
  data() {
    return {
      visible: false,
      agedDevice: this.$configer.SLHequment,
      ideDevice: this.$configer.equment,
    };
  },
  created() {
    // this.getData();
  },
  beforeDestroy() {},
  methods: {
    toDetail(data) {
      if (data == 1) {
        data = {
          name: "长者照护专用智能摄像头",
          total: "967",
          type: "9",
          visible: true,
        };
      }
      data.visible = true;
      PubSub.publish("JCEqument", data);
    },
    getData() {
      this.$api
        .CountDevice()
        .then((result) => {
          this.ideDevice = result.ideDevice;
          this.agedDevice = result.agedDevice;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.item-content {
  width: 100%;
  height: calc(100% - 2.314vh);
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.v-title {
  // display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  img {
    width: 30px;
    height: 30px;
    float: right;
    margin-top: 10px;
    margin-right: 10px;
    cursor: pointer;
  }
}
.SBI-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  padding: 10px 0px 10px 10px;
}
.sbI-left {
  width: 49%;
  height: 100%;
  font-size: 16px;
  color: #ffffff;
  p {
    cursor: pointer;
  }
  span {
    background: -webkit-linear-gradient(#58cef5, #0669fd);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: "pmzd";
    font-size: 20px;
  }
  div.title {
    font-size: 22px;
    background: -webkit-linear-gradient(#58cef5, #0669fd);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: "pmzd";
  }
}
.sbI-right {
  width: 49%;
  height: 100%;
  font-size: 16px;
  color: #ffffff;
  span {
    background: -webkit-linear-gradient(#f5c758, #fd6306);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: "pmzd";
    font-size: 20px;
  }
  div.title {
    background: -webkit-linear-gradient(#f5c758, #fd6306);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: "pmzd";
    font-size: 22px;
  }
}
.ElderlyData-content {
  width: 100%;
  height: 100%;
  // background-color: red;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
</style>
